export enum PromptTypes {
  NORMAL = "NORMAL",
  EDIT = "EDIT",
}

export interface PromptProps {
  title?: string
  message?: string
  onClose?: () => void
  onSuccess?: () => void
  onCancel?: () => void
  successText?: string
  cancelText?: string
}
